import { AuthGuard } from './auth-guards.service';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlSerializer } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { removeQueryParam } from '../misc/helper-functions.utils';

@Injectable()
export class AppCanActivate implements CanActivate {
  private _router = inject(Router);
  private _serializer = inject(UrlSerializer);

  authGuard = inject(AuthGuard);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authGuard.canActivate().pipe(
      map(() => {
        return true;
      })
    );
  }

  canActivateX(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const navObject = this._router.currentNavigation();

    if (navObject?.extras.state && navObject.extras.state['skipCanActivate']) {
      return of(true);
    }

    const tree = this._serializer.parse(state.url);
    const url = removeQueryParam(tree.toString(), 'ticket');
    this._router.navigateByUrl(url, {
      state: { skipCanActivate: true },
    });

    return of(false);
  }
}
